import React from 'react';
import { ConsentItem, ConsentItemProps } from '../ConsentItem/ConsentItem';
import { useTranslation } from "react-i18next";
import { Title } from '../Title/Title';
import { TypographyVariantModel, TypographyComponentModel, TypographyFontWeightModel } from '../Typography/tools/Typography.model';
import { useConsentGroup } from './useConsentGroup';
import { FormFieldset } from '../FormFieldset/FormFieldset';
import { FormLegend } from '../FormLegend/FormLegend';

import useStyles from './ConsentGroup.style';
export interface ConsentGroupProps {
  hideTitle?: boolean;
  title?: string;
  titleVariant?: TypographyVariantModel;
  titleComponent?: TypographyComponentModel;
  titleFontWeight?: TypographyFontWeightModel;
  description?: string;
  hasAcceptAllOption?: boolean;
  items: ConsentItemProps[];
  ariaLabelledBy?: string;
  onAcceptAllChange?: (checked: boolean) => void;
}

export const ConsentGroup: React.FC<ConsentGroupProps> = ({
  hideTitle = false,
  title,
  titleVariant = 'h3',
  titleComponent = 'h3',
  titleFontWeight = 'bold',
  description,
  hasAcceptAllOption = false,
  items,
  ariaLabelledBy,
  onAcceptAllChange,
}) => {
  const [t] = useTranslation('components');
  const c = useStyles({});

  const {
    consentStates,
    acceptAllChecked,
    handleConsentChange,
    handleAcceptAllChange,
  } = useConsentGroup({ items, hasAcceptAllOption, onAcceptAllChange });

  const allItemsDisabled = items.length > 0 && items.every(item => item.disabled);

  return (
    <FormFieldset ariaLabelledBy={ariaLabelledBy}>
      <FormLegend id={ariaLabelledBy} srOnly={hideTitle}>
        <Title
          title={title || t('consent-group.title')}
          titleVariant={titleVariant}
          titleComponent={titleComponent}
          titleFontWeight={titleFontWeight}
          description={description}
          descriptionColor='greys.60'
          className={c.title}
        />
      </FormLegend>
      <div>
        {hasAcceptAllOption &&
          <ConsentItem
            id="accept-all"
            name="accept-all"
            label={t('consent-group.accept-all')}
            className={c.consentItem}
            checked={acceptAllChecked}
            onChange={handleAcceptAllChange}
            disabled={allItemsDisabled}
          />
        }
        {items.map(item => (
          <ConsentItem
            {...item}
            key={item.id}
            name={item.id}
            checked={consentStates[item.id] || false}
            onChange={(checked: boolean) => handleConsentChange(item.id, checked)}
            className={c.consentItem}
          />
        ))}
      </div>
    </FormFieldset>
  )
};
